module.exports = __webpack_public_path__ + "img/zdrav_kontrol.5d1c3e56.png";